import NiceModal from '@ebay/nice-modal-react';
import { Box, Table, Text } from '@mantine/core';

import { useGetAccounts } from '../api/getAccounts';
import { hashRoleColor } from '../utils/roleColors';

import { AccountModal } from './AccountModal';
import { AccountRow } from './AccountRow';

import { AddButton, ListLoader } from '@/components';
import { useGetRoles } from '@/features/roles';

export const AccountsTable = () => {
  const { data, isLoading, isError } = useGetAccounts();
  const { data: rolesData, isLoading: isRolesLoading, isError: isRolesError } = useGetRoles();
  const { accounts = [] } = data || {};

  const roles = rolesData?.roles ?? [];
  const rolesMap = new Map(roles.map((role) => [role._id, role.name]));
  const colorsMap = new Map(roles.map((role) => [role._id, hashRoleColor(role._id)]));

  if (isLoading || isRolesLoading) {
    return <ListLoader />;
  }

  if (isError) {
    return <Text c="red">Failed to load accounts</Text>;
  }

  if (isRolesError) {
    return <Text c="red">Failed to load roles</Text>;
  }

  if (accounts.length === 0) {
    return (
      <Box
        style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}
      >
        <Text c="dimmed" size="sm" p="md">
          No accounts yet
        </Text>
        <AddButton
          size={60}
          onClick={() => NiceModal.show(AccountModal, {})}
          ariaLabel="Add account"
        />
      </Box>
    );
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <Table stickyHeader striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Username</Table.Th>
              <Table.Th>Roles</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {accounts.map((account) => (
              <AccountRow
                key={account._id}
                account={account}
                rolesMap={rolesMap}
                colorsMap={colorsMap}
              />
            ))}
          </Table.Tbody>
        </Table>
      </Box>
      <AddButton
        size={60}
        onClick={() => NiceModal.show(AccountModal, {})}
        ariaLabel="Add account"
      />
    </Box>
  );
};
